module.exports = __webpack_public_path__ + "img/15passenger_stopped.04b74ae2.svg";